import {
    GET_PROJECTS,
    GET_PROJECTS_SUCCESS,
    GET_PROJECTS_FAIL,
} from '../../../constants/actions/project.constants';

export default function (
    state = { isLoading: false, isLoaded: false },
    action: { type: string },
) {
    switch (action.type) {
        case GET_PROJECTS:
            return { ...state, isLoading: true };
        case GET_PROJECTS_SUCCESS:
            return { isLoading: false, isLoaded: true };
        case GET_PROJECTS_FAIL:
            return { ...state, isLoading: false };

        default:
            return state;
    }
}
